module.exports = __webpack_public_path__ + "img/rank-down.e96dd486.svg";